exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#success[data-v-12779db5]{height:40em;padding-bottom:100vh}.image[data-v-12779db5]{height:500;width:500;padding-bottom:3vh}#success div[data-v-12779db5]{margin:0;position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%,-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12779db5","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Success.vue
// module id = 500
// module chunks = 0